// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vision {
  background: linear-gradient(165deg, var(--ink-800) 0%, var(--ink-900) 100%);
}

.vision__inner {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
}

.vision__card {
  border-radius: var(--radius-lg);
  padding: 34px 28px;
  position: relative;
  overflow: hidden;
}

.vision__card--teal {
  background: linear-gradient(150deg, var(--teal), var(--teal-dark));
}

.vision__card--amber {
  background: linear-gradient(150deg, var(--amber), var(--amber-dark));
}

.vision__card--dark {
  background: var(--glass-dark-bg);
  backdrop-filter: blur(var(--glass-blur));
  -webkit-backdrop-filter: blur(var(--glass-blur));
  border: 1px solid var(--glass-dark-border);
}

.vision__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
  margin-bottom: 16px;
}

.vision__card h3 {
  color: #fff;
  font-size: 20px;
  font-weight: 800;
  margin: 12px 0 12px;
}

.vision__card p {
  color: rgba(255, 255, 255, 0.85);
  font-size: 14px;
}

.vision__card--dark p {
  color: rgba(255, 255, 255, 0.62);
}

@media (max-width: 900px) {
  .vision__inner {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Vision.css"],"names":[],"mappings":"AAAA;EACE,2EAA2E;AAC7E;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;EACxC,gDAAgD;EAChD,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".vision {\n  background: linear-gradient(165deg, var(--ink-800) 0%, var(--ink-900) 100%);\n}\n\n.vision__inner {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 22px;\n}\n\n.vision__card {\n  border-radius: var(--radius-lg);\n  padding: 34px 28px;\n  position: relative;\n  overflow: hidden;\n}\n\n.vision__card--teal {\n  background: linear-gradient(150deg, var(--teal), var(--teal-dark));\n}\n\n.vision__card--amber {\n  background: linear-gradient(150deg, var(--amber), var(--amber-dark));\n}\n\n.vision__card--dark {\n  background: var(--glass-dark-bg);\n  backdrop-filter: blur(var(--glass-blur));\n  -webkit-backdrop-filter: blur(var(--glass-blur));\n  border: 1px solid var(--glass-dark-border);\n}\n\n.vision__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 46px;\n  height: 46px;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.18);\n  color: #fff;\n  margin-bottom: 16px;\n}\n\n.vision__card h3 {\n  color: #fff;\n  font-size: 20px;\n  font-weight: 800;\n  margin: 12px 0 12px;\n}\n\n.vision__card p {\n  color: rgba(255, 255, 255, 0.85);\n  font-size: 14px;\n}\n\n.vision__card--dark p {\n  color: rgba(255, 255, 255, 0.62);\n}\n\n@media (max-width: 900px) {\n  .vision__inner {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
